import registerPromiseWorker from 'promise-worker/register';
import getFeasibilitySVGString from '../../feasibility/exports/getSVGString';
import getProductSpaceSVGString from '../../network/exports/getSVGString';
import getRingsSVGString from '../../rings/exports/getSVGString';
import getStackSVGString from '../../stack/exports/getSVGString';
import getTreeSVGString from '../../tree/newExports/getSVGString';
import {
  failIfValidOrNonExhaustive,
} from '../../Utils';
import {
  SVGWorkerMessage,
  SVGWorkerMessageType,
} from './Utils';

export const getSVG = (input: SVGWorkerMessage): string => {
  switch (input.type) {
    case SVGWorkerMessageType.TREE_EXPORT_SVG:
      return getTreeSVGString(input.content);

    case SVGWorkerMessageType.STACK_EXPORT_SVG:
      return getStackSVGString(input.content);

    case SVGWorkerMessageType.PRODUCT_SPACE_EXPORT_SVG:
      return getProductSpaceSVGString(input.content);

    case SVGWorkerMessageType.FEASIBILITY_EXPORT_SVG:
      return getFeasibilitySVGString(input.content);

    case SVGWorkerMessageType.RINGS_EXPORT_SVG:
      return getRingsSVGString(input.content);

    default:
      failIfValidOrNonExhaustive(input, 'Invalid worker message type');
      return '';
  }
};

registerPromiseWorker(
  (message: SVGWorkerMessage) => getSVG(message),
);
